export const INITIATIVE = {
  initiative: 'Initiative',
  tabTasks: 'Tasks',
  tabHuddles: 'Notes',
  tabIdeation: 'Ideation',
  participants: 'Participants',
  teams: 'Teams',
  email: 'Email',
  name: 'Name',
  owner: 'Owner',
  contributors: 'Contributors',
  createNewInitiative: 'Create new initiative',
  createNewInitiativeTitle:
    'Create an initiative from scratch or select one of the many templates available',
  preview: 'Preview',
  createCustomInitiative: 'Create a new custom initiative',
  useTemplate: 'Use template',
  allTemplates: 'All templates',
  title: 'Title',
  initiativeMembers: 'Initiative members',
  addInitiativeToHomePage: 'Click here to feature it on the home page.',
  removeInitiativeFromHomePage: 'Click to remove from the home page.',
  editInitiative: 'Edit initiative',
  closeInitiative: 'Close initiative',
  confirmCloseInitiative: 'Are you sure you want to close this initiative?',
  failedToLoadInitiative: 'Failed to load initiative',

  // --- Header ---
  back: 'Back',
  due: 'Due',
  noOwner: 'No owner',
  changeStatus: 'Change status',
  initiativeSettings: 'Initiative settings',
  viewMembers: 'View initiative members',

  // --- Context rail ---
  context: 'Context',
  closeContext: 'Close panel',
  openContext: 'Open context panel',
  whyThisInitiative: 'Why this initiative',
  noDescription: 'No description yet.',
  railActivity: 'Activity',
  railNotes: 'Notes',
  railIdeation: 'Ideation',
  noNotesYet: 'No notes yet.',
  notesFailed: 'Notes could not be loaded.',
  newNoteTitle: 'New note',
  saveNote: 'Save',
  seeMore: 'See more',
  emptyNote: 'Empty note',
  editNote: 'Edit note',
  deleteNote: 'Delete note',
  edit: 'Edit',
  people: 'People',
  noMembers: 'This initiative has no people yet.',
  turnIntoTask: 'Turn into a task',
  comment: 'Comment',
  noIdeationsYet: 'No ideations yet.',
  ideationsFailed: 'Ideations could not be loaded.',
  created: 'Created',
  lastAccess: 'Last access',
  commentsCount: 'Comments',
  deleteIdeation: 'Delete ideation',
  openIdeation: 'Open ideation',
  lastReviewed: 'Last reviewed',
  weeklyReview: 'Weekly review',

  // --- Activity feed ---
  activityLoading: 'Loading activity…',
  activityFailed: 'Activity could not be loaded.',
  noActivityYet: 'No activity yet.',
  loadOlderActivity: 'Load older activity',
  olderActivityFailed: "Couldn't load older activity.",
  retry: 'Retry',
  endOfActivity: "That's all the activity.",
  // Prefixed with the count: "30 older activity items loaded".
  activityLoadedMore: 'older activity items loaded',
  today: 'Today',
  yesterday: 'Yesterday',
  tagCreated: 'Created',
  tagUpdated: 'Updated',
  tagStatus: 'Status',
  tagBlocked: 'Blocked',
  tagUnblocked: 'Unblocked',
  tagDeleted: 'Deleted',
  tagComment: 'Comment',
  tagCommentDeleted: 'Comment deleted',

  // --- Completion progress ---
  of: 'of',
  ofCompleted: 'completed',
  closedNotCounted: 'closed, not counted',
  tasks: 'tasks',
  task: 'task',
} as const
